import React from 'react'
import styled from 'styled-components'
import { Button } from 'primereact/button'

import { ChargingSessionType } from '../../common/types/chargingSessionType'
import Text from '../../ui/Text'
import { LatestChargingSessionsConnectorInfo } from '../latest-charging-sessions-connector-info'
import { dateLocalize } from '../date-localize'
import { WidgetLayout } from '../widget-layout'
import { isMoreItemsToLoad } from '../is-more-items-to-load'
import { ChargingSession } from '../../common/redux/api/web-api'
import useText from '../../common/hooks/useText'

const THead = styled.thead`
    height: 40px;
`

const TTitle = styled.th`
    font-size: 14px;
`

const ButtonContainer = styled.div`
    display: flex;
    width: inherit;
    align-items: center;
    justify-content: center;
`

export const CHARGING_SESSIONS_USER_NO_OF_ITEMS = 10

export type LatestChargingSessionsUserProps = {
    sessions: Array<ChargingSessionType | ChargingSession>
    showEndTime: boolean
    loadMoreChargingSessions?: () => void
    loading?: boolean
}

export function LatestChargingSessionsUser({
    sessions,
    loadMoreChargingSessions,
    loading,
    showEndTime,
}: LatestChargingSessionsUserProps): React.ReactElement {
    const text = useText()

    return (
        <WidgetLayout title={text('lblMyLatestChargingSessionsWidget')} data-testid="latest-charging-session">
            <div className="table-container" data-testid="chargingSessionContainer">
                <table className="table table-striped table-hover">
                    <THead>
                        <tr>
                            <TTitle className="heading5" data-testid="row-charger">
                                <Text code="lblCharger"></Text>
                            </TTitle>

                            <TTitle className="heading5" data-testid="row-socket">
                                <Text code="lblSocket"></Text>
                            </TTitle>

                            <TTitle className="heading5" data-testid="row-start">
                                <Text code="lblStart"></Text>
                            </TTitle>

                            {showEndTime && (
                                <TTitle className="heading5" data-testid="row-end">
                                    <Text code="lblStop"></Text>
                                </TTitle>
                            )}

                            <TTitle className="heading5" data-testid="row-total">
                                <Text code="lblTotalKWh"></Text>
                            </TTitle>
                        </tr>
                    </THead>
                    <tbody>
                        {sessions?.map((session, i) => (
                            <tr key={i}>
                                <td className="text5" data-testid={`name-${i}`}>
                                    {session.chargePointName}
                                </td>
                                <td className="text5" data-testid={`icons-${i}`}>
                                    <LatestChargingSessionsConnectorInfo chargingSession={session} />
                                </td>
                                <td className="text5" data-testid={`startTime-${i}`}>
                                    {dateLocalize(session.startTime)}
                                </td>
                                {showEndTime && (
                                    <td className="text5" data-testid={`endTime-${i}`}>
                                        {dateLocalize(session.endTime)}
                                    </td>
                                )}
                                <td className="text5" data-testid={`totalKwH-${i}`}>
                                    {session?.totalConsumptionKwh?.toFixed(3)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {loadMoreChargingSessions && isMoreItemsToLoad(CHARGING_SESSIONS_USER_NO_OF_ITEMS, sessions.length) && (
                <ButtonContainer>
                    <Button
                        type="button"
                        label={text('btnLoadMore')}
                        icon="pi pi-chevron-down"
                        iconPos="right"
                        onClick={() => loadMoreChargingSessions()}
                        loading={loading}
                    />
                </ButtonContainer>
            )}
        </WidgetLayout>
    )
}
